import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import { api } from "../lib/api";
import { setFileType } from "../../store/file-slice";

export function useSelectContract() {
	const dispatch = useDispatch();
	return useMutation({
		mutationFn: async ({
			fileId,
			code,
			name,
			userId, // TODO: remove this after this API is fixed
		}: {
			fileId: string;
			code: string;
			name: string;
			userId: string;
		}) => {
			const res: any = await api.post("/api/v1/contracts/change-contract-type", {
				userId,
				contractData: [{ fileId, code, name }],
			});

			if (!res.success) {
				throw new Error(res.message ?? "Failed to change the contract type");
			}
		},
		onSuccess: (_, { name, code }) => {
			dispatch(
				setFileType({
					label: name,
					value: code,
				})
			);
		},
	});
}
